// [MCV-1906] The server returns a bare array and defaults to page 1 of 5, so the
// client has to ask for its page size explicitly; a shorter-than-requested page
// is how the machine knows there is no more. Kept out of api.ts because specs
// replace that whole module with a mock.
export const CONTRACTS_PAGE_SIZE = 20;

// [MCV-1936] The server rejects a pageSize above 100. A reload after an action asks for
// every row loaded so far in one request, capped here.
export const CONTRACTS_MAX_PAGE_SIZE = 100;
